var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamaskLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 80,
    viewBox: "0 0 86 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8 0.900024L48 25.3L54.1 10.9L80.8 0.900024Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 0.900024L37.6 25.5L31.8 10.9L4.99997 0.900024Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 57.4L60.2 70.8L79 76L84.3 57.7L69 57.4Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 57.7L6.89998 76L25.6 70.8L16.9 57.4L1.59998 57.7Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 34.8L19.4 42.7L37.9 43.5L37.3 23.5L24.6 34.8Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3 34.8L48.4 23.3L48 43.5L66.5 42.7L61.3 34.8Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 70.8L36.8 65.4L27.1 57.8L25.6 70.8Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1 65.4L60.2 70.8L58.7 57.8L49.1 65.4Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 70.8L49.1 65.4L50 72.6L49.9 75.7L60.2 70.8Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 70.8L36 75.7L35.9 72.6L36.8 65.4L25.6 70.8Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 53L26.9 50.3L33.4 47.3L36.2 53Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 53L52.4 47.3L59 50.3L49.7 53Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 70.8L27.2 57.4L16.9 57.7L25.6 70.8Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 57.4L60.2 70.8L69 57.7L58.7 57.4Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 42.7L48 43.5L49.7 53L52.4 47.3L59 50.3L66.5 42.7Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 50.3L33.4 47.3L36.2 53L37.9 43.5L19.4 42.7L26.9 50.3Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 42.7L27.1 57.8L26.9 50.3L19.4 42.7Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50.3L58.7 57.8L66.5 42.7L59 50.3Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 43.5L36.2 53L38.3 64.3L38.8 49.4L37.9 43.5Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43.5L47.1 49.4L47.5 64.3L49.7 53L48 43.5Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 53L47.5 64.3L49.1 65.4L58.7 57.8L59 50.3L49.7 53Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 50.3L27.1 57.8L36.8 65.4L38.3 64.3L36.2 53L26.9 50.3Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 75.7L50 72.6001L49.1 71.9H36.7L35.9 72.6001L36 75.7L25.6 70.8L29.2 73.8L36.6 78.9H49.2L56.6 73.8L60.2 70.8L49.9 75.7Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1 65.4L47.5 64.3H38.3L36.8 65.4L35.9 72.6001L36.7 71.9H49.1L50 72.6001L49.1 65.4Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2 26.9L85 13.4L80.8 0.900024L49.1 24.5L61.3 34.8L78.5 39.8L82.3 35.4L80.7 34.2L83.3 31.8L81.3 30.2L83.9 28.2L82.2 26.9Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899994 13.4L3.69999 26.9L1.89999 28.2L4.49999 30.2L2.49999 31.8L5.19999 34.2L3.49999 35.4L7.3 39.8L24.6 34.8L36.8 24.5L4.99999 0.900024L0.899994 13.4Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 39.8L61.3 34.8L66.5 42.7L58.7 57.8L69 57.7H84.3L78.5 39.8Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 34.8L7.29998 39.8L1.59998 57.7H16.9L27.1 57.8L19.4 42.7L24.6 34.8Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43.5L49.1 24.5L54.1 10.9H31.8L36.8 24.5L37.9 43.5L38.3 49.5V64.3H47.5V49.5L48 43.5Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskLogo);
export default __webpack_public_path__ + "static/media/metamask-logo.6d9734d30424b088d0b6c6fbb03fbeda.svg";
export { ForwardRef as ReactComponent };